    // window.addEventListener('load', () => {
    //     let anchor = window.location.hash; 

    //     // if (target.href.indexOf('/')) {
    //     //     anchor = anchor.substring(anchor.indexOf('/') + 1);

    //     //     location.hash = '#' + anchor;
    //     // }

    //     setTimeout(() => {
    //         console.log('scrolling');
    //         document.querySelector('a' + anchor).scrollIntoView(true);
    //     }, 500)

    // })

    // document.addEventListener('click', (event) => {
    //     if (event.target.matches('a') && event.target.href.indexOf('#') > 0) {
    //         console.log("Hello!");

    //         event.preventDefault();

    //         let anchor = event.target.href;

    //         console.log('hash', anchor);

    //         anchor = anchor.substring(anchor.indexOf('#') + 1);

    //         console.log("Finding ", anchor)

    //         document.querySelector('#' + anchor).scrollIntoView(true);
    //     } else {
    //         console.log('not a match');
    //     }
    // })